module.exports = __webpack_public_path__ + "static/media/NPM.a363d0b9.svg";